var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEditIcon = function SvgEditIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#5656FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3334 12.0334C24.3341 11.9238 24.313 11.815 24.2716 11.7135C24.2301 11.612 24.169 11.5196 24.0918 11.4418L20.5584 7.90843C20.4806 7.83119 20.3882 7.77009 20.2867 7.72862C20.1852 7.68715 20.0764 7.66613 19.9668 7.66676C19.8571 7.66613 19.7484 7.68715 19.6468 7.72862C19.5453 7.77009 19.453 7.83119 19.3751 7.90843L17.0168 10.2668L7.90843 19.3751C7.83119 19.453 7.77009 19.5453 7.72862 19.6468C7.68715 19.7484 7.66613 19.8571 7.66676 19.9668V23.5001C7.66676 23.7211 7.75456 23.9331 7.91084 24.0893C8.06712 24.2456 8.27908 24.3334 8.5001 24.3334H12.0334C12.15 24.3398 12.2667 24.3215 12.3758 24.2799C12.4849 24.2383 12.584 24.1742 12.6668 24.0918L21.7251 14.9834L24.0918 12.6668C24.1678 12.586 24.2298 12.493 24.2751 12.3918C24.2831 12.3253 24.2831 12.2582 24.2751 12.1918C24.279 12.153 24.279 12.1139 24.2751 12.0751L24.3334 12.0334ZM11.6918 22.6668H9.33343V20.3084L17.6084 12.0334L19.9668 14.3918L11.6918 22.6668ZM21.1418 13.2168L18.7834 10.8584L19.9668 9.68343L22.3168 12.0334L21.1418 13.2168Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/editIcon.b6195593.svg";
export { ForwardRef as ReactComponent };